export default "__VITE_ASSET__BSCujsuO__"